module.exports = __webpack_public_path__ + "static/img/so3_1.586c074.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/pic/so3_1.jpg
// module id = KOY7
// module chunks = 11